import { render, staticRenderFns } from "./os.vue?vue&type=template&id=3827b6e2&scoped=true&"
import script from "./os.vue?vue&type=script&lang=js&"
export * from "./os.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3827b6e2",
  null
  
)

export default component.exports